import {
	useEffect,
	useState,
} from 'react';
import './checkbox.scss';

interface CheckboxProps {
	label: string,
	children?: JSX.Element | string;
	checked?: boolean,
	onChange: (checked: boolean) => void,
}

const Checkbox = ({
	label,
	children,
	checked = false,
	onChange,
}: CheckboxProps
) => {
	const [isChecked, setIsChecked] = useState(false);

	useEffect(() => {
		setIsChecked(checked)
	}, [checked]);

	return (
		<div className="checkbox">
			<input
				type="checkbox"
				id={label}
				name={label}
				checked={isChecked}
				onChange={() => {
					onChange(!isChecked);
					setIsChecked(!isChecked);
				}}
			/>
			{children ? children : label}
		</div>
	);
}

export default Checkbox;